/* eslint-disable simple-import-sort/sort */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import de from 'react-phone-input-2/lang/de.json';
import es from 'react-phone-input-2/lang/es.json';
import fr from 'react-phone-input-2/lang/fr.json';
import 'react-phone-input-2/lib/bootstrap.css';

import Html from 'Component/Html';
import { RefType } from 'Type/Common.type';

import './FieldPhoneNumber.style';

/** @namespace PeggysagePwa/Component/FieldPhoneNumber/Component */
export class FieldPhoneNumberComponent extends PureComponent {
    static propTypes = {
        currentStoreCode: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        subLabel: PropTypes.string.isRequired,
        inputProps: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool
        ])).isRequired,
        errorMessage: PropTypes.string.isRequired,
        fieldRef: RefType.isRequired,
        onChange: PropTypes.func.isRequired,
        hasFloatingLabel: PropTypes.bool.isRequired
    };

    renderSubLabel() {
        const { subLabel } = this.props;

        if (!subLabel) {
            return null;
        }

        return (
            <div block="Field" elem="SubLabelContainer">
                <div block="Field" elem="SubLabel">
                    <Html content={ subLabel.toString() } />
                </div>
            </div>
        );
    }

    render() {
        const {
            currentStoreCode,
            onChange,
            errorMessage,
            label,
            inputProps,
            inputProps: {
                id,
                // defaultValue: value = '',
                required: isRequired = false
            } = {},
            fieldRef,
            hasFloatingLabel
        } = this.props;

        const langCode = currentStoreCode.substr(0, 2).toLowerCase();
        // eslint-disable-next-line no-magic-numbers
        const countryCode = currentStoreCode.substr(3, 2).toLowerCase();

        // shorthands of react-phone-input-2 lang json (cf imports)
        const localizations = { fr, es, de };

        const localization = localizations[langCode];

        const classNames = ['Field-Wrapper', 'Field-Wrapper_type_text'];
        if (hasFloatingLabel) {
            classNames.push('Field-Wrapper_hasFloatingLabel');
        }

        return (
            <div
              block="FieldPhoneNumber"
              className={ classNames.join(' ') }
              ref={ fieldRef }
            >
                <div className="Field Field_type_text ">
                    <div className="Field-LabelContainer">
                        <label htmlFor={ id } className="Field-Label">
                            { label }
                            { isRequired && (
                                <span className="Field-Label Field-Label_isRequired"> *</span>
                            ) }
                        </label>
                    </div>
                    <PhoneInput
                      inputProps={ inputProps }
                      // value={ value }
                      country={ countryCode }
                      localization={ localization }
                      countryCodeEditable={ false }
                      enableSearch
                      disableSearchIcon
                      disableDropdown
                      searchPlaceholder={ __('Search') }
                      searchNotFound={ __('No entries to show') }
                      isValid={ !errorMessage }
                      onChange={ onChange }
                      masks={ { de: '...........' } }
                    />
                    <div block="Field" elem="ErrorMessages">
                        <div
                          block="Field"
                          elem="ErrorMessage"
                          mods={ { isVisible: !!errorMessage } }
                        >
                            { errorMessage }
                        </div>
                    </div>
                    { this.renderSubLabel() }
                </div>
            </div>
        );
    }
}

export default FieldPhoneNumberComponent;
